export const actions = {
  IVAS_LOAD_REQUESTED: 'IVAS_LOAD_REQUESTED',
  IVAS_LOAD_SUCCEEDED: 'IVAS_LOAD_SUCCEEDED',
  IVAS_LOAD_FILED: 'IVAS_LOAD_FILED',

  IVAS_DESCRIPCION_LOAD_REQUESTED: 'IVAS_DESCRIPCION_LOAD_REQUESTED',
  IVAS_DESCRIPCION_LOAD_SUCCEEDED: 'IVAS_DESCRIPCION_LOAD_SUCCEEDED',
  IVAS_DESCRIPCION_LOAD_FILED: 'IVAS_DESCRIPCION_LOAD_FILED',

  IVA_DESCRIPCION_INSERT_REQUESTED: 'IVAS_DESCRIPCION_INSERT_REQUESTED',
  IVA_DESCRIPCION_INSERT_SUCCEEDED: 'IVAS_DESCRIPCION_INSERT_SUCCEEDED',
  IVA_DESCRIPCION_INSERT_FAILED: 'IVAS_DESCRIPCION_INSERT_FAILED',

  IVA_DESCRIPCION_UPDATE_REQUESTED: 'IVAS_DESCRIPCION_UPDATE_REQUESTED',
  IVA_DESCRIPCION_UPDATE_SUCCEEDED: 'IVAS_DESCRIPCION_UPDATE_SUCCEEDED',
  IVA_DESCRIPCION_UPDATE_FAILED: 'IVAS_DESCRIPCION_UPDATE_FAILED',

  IVA_DESCRIPCION_DELETE_REQUESTED: 'IVAS_DESCRIPCION_DELETE_REQUESTED',
  IVA_DESCRIPCION_DELETE_SUCCEEDED: 'IVAS_DESCRIPCION_DELETE_SUCCEEDED',
  IVA_DESCRIPCION_DELETE_FAILED: 'IVAS_DESCRIPCION_DELETE_FAILED',
}

export const getIvasAction = dispatch => {
  dispatch({
    type: actions.IVAS_LOAD_REQUESTED,
  })
}

export const getIvaDescripcionesAction = dispatch => {
  dispatch({
    type: actions.IVAS_DESCRIPCION_LOAD_REQUESTED,
  })
}

export const insertIvaDescripcionesAction = (dispatch, payload) => {
  dispatch({
    type: actions.IVA_DESCRIPCION_INSERT_REQUESTED,
    payload,
  })
}

export const updateIvaDescripcionesAction = (dispatch, payload) => {
  dispatch({
    type: actions.IVA_DESCRIPCION_UPDATE_REQUESTED,
    payload,
  })
}

export const deleteIvaDescripcionesAction = (dispatch, id) => {
  dispatch({
    type: actions.IVA_DESCRIPCION_DELETE_REQUESTED,
    id,
  })
}
